// modules/b2b/modals/ModalCreateCompanyB2B.tsx
import { Modal } from "flowbite-react";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { ICompanyB2B } from "@/types/companyB2B.type";
import { createCompanyB2B } from "@/common/services/company-b2b.api";
import FormCreateCompanyB2B from "../form/FormCreateCompanyB2B";

type Props = {
  data: ICompanyB2B;
  onClose: () => void;
  onSave: (empresa: ICompanyB2B) => void;
  isOpen: boolean;
};

export default function ModalCreateCompanyB2B(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();

  const handleCloseModal = () => {
    props.onClose();
  };

  async function handleSubmit(dataToSave) {
    try {
      // O backend adiciona companyId, active, createdAt e updatedAt.
      const result = await createCompanyB2B(dataToSave);

      const { ok, data } = result;
      if (ok && data) {
        props.onSave(data as ICompanyB2B);
        notifySuccess(
          `Empresa B2B "${(data as ICompanyB2B).name}" cadastrada!`
        );
      }
      if (!result.ok) {
        notifyError(
          (result as { message?: string })?.message ||
          "Erro ao cadastrar empresa."
        );
      }
    } catch (err) {
      console.error(err);
      notifyError((err as Error).message || "Erro desconhecido ao cadastrar.");
    }
  }

  return (
    <Modal
      className="relative text-black"
      show={props.isOpen}
      onClose={() => handleCloseModal()}
      size="5xl"
    >
      <Modal.Header className="text-black">
        <h2 className="text-black">Nova Empresa B2B</h2>
      </Modal.Header>
      <Modal.Body>
        <FormCreateCompanyB2B onSubmit={handleSubmit} />
      </Modal.Body>
    </Modal>
  );
}
